<template>
  <el-dialog
    class="share-dialog"
    :title="$t('text.send_email')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div>
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="60px"
        class="demo-dynamic"
      >
        <el-form-item
          v-for="(email, index) in dynamicValidateForm.emails"
          :label="$t('text.email') + (index + 1)"
          :key="email.key"
          :prop="'emails.' + index + '.value'"
          :rules="[
            {
              required: true,
              message: $t('text.please_enter_email_address'),
              trigger: 'blur'
            },
            {
              type: 'email',
              message: $t('text.please_enter_the_correct_email_address'),
              trigger: ['blur', 'change']
            }
          ]"
        >
          <el-input v-model="email.value"></el-input>
          <div class="inline-block">
            <div
              class="delete-item operate-item-btn"
              @click.prevent="removeEmail(email)"
            >
              <img src="@/assets/image/delete.svg" class="w-20" />
            </div>
          </div>
        </el-form-item>
        <el-form-item class="btn-wrapper">
          <el-button
            type="primary"
            :loading="loading"
            :disabled="loading"
            class="save-btn"
            @click="submitForm('dynamicValidateForm')"
            >{{ $t('text.send') }}</el-button
          >
          <el-button @click="closeDialog()" class="cancel-btn">{{
            $t('text.cancel')
          }}</el-button>
          <el-button
            icon="el-icon-plus"
            @click="addEmail"
            class="right-float mt-3 save-btn"
            >{{ $t('text.add_email') }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import html2canvas from 'html2canvas'
import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      dynamicValidateForm: {
        emails: [
          {
            value: ''
          }
        ]
      },
      loading: false,
      activeName: ''
    }
  },
  computed: {
    emailContent() {
      return () => {
        let content
        switch (this.activeName) {
          case 'voiding_pattern':
            content = this.$t('text.voiding_chart_email_content')
            break
          case 'smartz_events':
            content = this.$t('text.smartz_events_chart_email_content')
            break
          case 'pad_fill_profile':
            content = this.$t('text.pad_fill_profile_chart_email_content', {
              pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
            })
            break
          case 'position_profile':
            content = this.$t('text.position_chart_email_content')
            break
          case 'temperature':
            content = this.$t('text.temperature_chart_email_content')
            break
          case 'heart_rate':
            content = this.$t('text.heare_rate_chart_email_content')
            break
          case 'oximetry':
            content = this.$t('text.oximtry_chart_email_content')
            break
          case 'respiration':
            content = this.$t('text.respiration_chart_email_content')
            break
          case 'balance':
            content = this.$t('text.balance_chart_email_content')
            break
          case 'smartz_devices':
            content = this.$t('text.smartz_chart_email_content')
            break
          case 'inco_assessment':
            content = this.$t('text.inco_assessment_email_content')
            break
          case 'observation_chart':
            content = this.$t('text.inco_observation_chart_content')
            break
          case 'physical_activity_chart':
            content = this.$t('text.physical_activity_chart_content')
            break
          default:
            content = this.$t('text.smartz_chart_email_content')
            break
        }
        return content
      }
    }
  },
  methods: {
    openDialog(activeName) {
      this.dialogVisible = true
      this.activeName = activeName
      this.dynamicValidateForm = {
        emails: [
          {
            value: ''
          }
        ]
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let dom = this.$parent.$refs.print
          let width = '1600px'
          if (
            [
              'temperature',
              'heart_rate',
              'oximetry',
              'respiration',
              'balance'
            ].includes(this.activeName)
          ) {
            dom = this.$parent.$refs.printSection.$refs.print
            width = '1200px'
          }
          if (['voiding_pattern', 'smartz_events'].includes(this.activeName)) {
            width = '2200px'
          }
          if (this.activeName === 'smartz_devices') {
            width = '1000px'
          }
          this.sendEmailConvertImg(dom, width)
        } else {
          return false
        }
      })
    },
    sendEmailConvertImg(dom, width) {
      this.loading = true
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      html2canvas(dom, {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false,
        onclone: function(doc) {
          $(doc)
            .find('body')
            .css('width', width)
          $(doc)
            .find('.new-design .sidebar-type-page-content')
            .css('width', '100%')
          $(doc)
            .find('.new-design .page-card-wrapper')
            .css('max-width', 'unset')
          $(doc)
            .find('.new-design .page-card-wrapper .page-card-content')
            .css('height', 'auto')
          $(doc)
            .find('.new-design .chart-filters .filter-row-wrapper .filter-item')
            .css('display', 'inline-block')
          $(doc)
            .find('.show-mobile')
            .css('display', 'none')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .page-card-title-text'
            )
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .left-side-text'
            )
            .css('display', 'inline-block')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .date-wrapper'
            )
            .css('position', 'absolute')
            .css('top', '6px')
            .css('right', '10px')
          $(doc)
            .find('.el-range-editor .el-range-input')
            .css('line-height', '24px')
          $(doc)
            .find('.pad-fill-profile-wrapper .volume-char-wrapper')
            .css('display', 'flex')
            .css('align-items', 'center')
            .css('justify-content', 'center')
          $(doc)
            .find('.pad-fill-profile-wrapper .left-card')
            .css('width', 'calc(100% * 0.875 - 15px * 0.875)')
          $(doc)
            .find('.pad-fill-profile-wrapper .left-card .profile-item-wrapper')
            .css('width', '100%')
          $(doc)
            .find('.pad-fill-profile-wrapper .right-card')
            .css('width', 'calc(100% * 0.125 - 15px * 0.125)')
            .css('margin-left', '15px')
          $(doc)
            .find('.pad-fill-profile-wrapper .right-card .profile-item')
            .css('width', '100%')
          $(doc)
            .find('.pad-fill-profile-wrapper .right-side')
            .css('float', 'right')
          $(doc)
            .find('.position-profile-page .chart-wrapper')
            .css('min-height', 'unset')
          $(doc)
            .find('#detail-table-wrapper')
            .css('display', 'block')
          $(doc)
            .find('.el-table th')
            .css('display', 'table-cell')
          $(doc)
            .find('.position-profile-page .legend')
            .css('display', 'inline-block')
            .css('float', 'right')
            .css('margin-top', 0)
          $(doc)
            .find('.position-profile-page .legend-item-wrapper')
            .css('width', 'auto')
            .css('margin-top', 0)
          $(doc)
            .find('.pdf-section')
            .css('display', 'block')
          $(doc)
            .find('.pdf-section .chart-card')
            .css('width', '100%')
            .css('height', '550px')
          $(doc)
            .find('.pdf-section .detail-wrapper')
            .css('height', 'auto')
          $(doc)
            .find('.new-design .smartz-devices-page .device-item')
            .css('max-width', 'unset')
            .css('width', '950px')
          $(doc)
            .find('.new-design .smartz-events-page .legend')
            .css('width', '100%')
            .css('display', 'flex')
          $(doc)
            .find(
              '.new-design .smartz-events-page .legend .legend-title,  .new-design .smartz-events-page .legend .legend-group'
            )
            .css('margin-right', '80px')
          $(doc)
            .find('.new-design .voiding-page .view-mode')
            .css('width', '50%')
            .css('display', 'inline-block')
          $(doc)
            .find('.new-design .voiding-page .legend')
            .css('width', '50%')
            .css('display', 'inline-flex')
            .css('justify-content', 'flex-end')
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .voiding-page .legend .legend-title,  .new-design .voiding-page .legend .legend-group:not(:last-child)'
            )
            .css('margin-right', '80px')
        }
      }).then(canvas => {
        let imageUrl = canvas.toDataURL('image/png')
        let domContent = `<img style="width: 100%" src=${imageUrl} />`
        this.handleSendEmail(domContent)
      })
    },
    handleSendEmail(domContent) {
      let recipients = this.dynamicValidateForm.emails.map(item => {
        return item.value
      })
      this.loading = true

      let data = {
        recipients: recipients,
        subject: decodeURI(encodeURI(this.$parent.subject)),
        emailContent: decodeURI(encodeURI(this.getEmailContent())),
        fileContent: this.setStyle(domContent),
        reportName: decodeURI(encodeURI(this.$parent.subject)) + '.pdf'
      }

      let formData = new FormData()
      formData.append('file', new Blob([JSON.stringify([data])]))

      ApiService.SendEmail(formData)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.sent_successfully')
            })
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.sent_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.sent_failed')
          })
        })
    },
    getEmailContent() {
      return `
        <!DOCTYPE html>
        <html >
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width,initial-scale=1">
            <style>  
            </style>
        </head>
        <body>
          <div>${this.$t('text.hi_everyone')},</div>
          <div style="margin-left: 20px">${this.emailContent()}</div>
          <br />
          <div>${this.$t('text.best_regards')},</div>
          <div>${this.$t('text.the_simavita_team')}</div>
        </body>
        </html>
      `
    },
    setStyle(html) {
      return `
        <!DOCTYPE html>
        <html >
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width,initial-scale=1">
        </head>
        <body>
          ${html} 
        </body>
        </html>
  `
    },
    resetForm() {
      this.$refs['dynamicValidateForm'].resetFields()
    },
    removeEmail(item) {
      if (this.dynamicValidateForm.emails.length === 1) {
        this.$message({
          message: 'Please enter at least one email address',
          type: 'warning'
        })
        return false
      }
      var index = this.dynamicValidateForm.emails.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.emails.splice(index, 1)
      }
    },
    addEmail() {
      this.dynamicValidateForm.emails.push({
        value: '',
        key: Date.now()
      })
    }
  }
}
</script>
